import React, { useEffect, useState } from "react";
import { FieldContainer } from "../common/FieldContainer";
import { IUseDropArgs } from "../common/dnd";
import './MobilePageLayout.scss'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateUUID, getRandomIcon, hasValue, tryParseJSON } from "../../util";
import tinycolor from "tinycolor2";
import IconEditor, { generateIconProp } from "../common/icon-selector/IconEditor";
import { SelectableItem } from "../common/SelectableItem";
import { IPropertyEditorProps, addToPath } from "../common/common";
import { PropertyContainer, PropertyGroup, PropertyGroupTitle } from "../common/ui-props/common";
import { AutoCompleteInput, Button, Input, Label, Select, useAlert } from "uxp/components";
import jp from 'jsonpath'
import { IContextProvider } from "../../uxp";
import ActionEditorLink, { IAction } from "../common/action-editor/ActionEditor";
import classNames from "classnames";

interface IMobilePageLayoutProps extends IUseDropArgs {
    loginLogo: string,
    backgroundImage: string
    logo: string
    backgroundColor: string
    bottomNavigationBarBackgroundColor: string
    bottomNavagationBarSelectedItemColor: string
    bottomNavigationBarUnselectedItemColor: string
    hideLucyLogo: boolean
    view: string
    zoom: number,
    appBarHeight: string
    appBarBackgroundColor: string,
    appBarBackgroundImage: string,
    appBarText: string,
    textColor: string,
    tabs: IMobileNavigationTab[]
    selectedTab: IMobileNavigationTab,
    onChangeTab: (tab: IMobileNavigationTab) => void
}

export interface IMobileNavigationTab {
    id: string,
    type: 'sections' | 'widget' | 'mobile' | 'on-click'
    label: string,
    icon: string,
    props: any,
    location: 'navigation-bar' | 'app-header'
}

interface ISettingsPageSection {
    id: string,
    label: string,
    icon: string,
    onClick: IAction
}

const lucyLogoLight = 'https://static.iviva.com/lucy/logos/lucy-canvas-white.svg'
const lucyLogoDark = 'https://static.iviva.com/lucy/logos/lucy-canvas.svg'
export const MobilePageLayout: React.FunctionComponent<IMobilePageLayoutProps> = (props) => {

    let { loginLogo, backgroundImage, logo, backgroundColor, bottomNavagationBarSelectedItemColor, bottomNavigationBarBackgroundColor, bottomNavigationBarUnselectedItemColor, view, zoom } = props

    if (!hasValue(backgroundColor)) backgroundColor = 'white'
    if (!hasValue(bottomNavigationBarBackgroundColor)) bottomNavigationBarBackgroundColor = 'white'
    if (!hasValue(bottomNavigationBarUnselectedItemColor)) bottomNavigationBarUnselectedItemColor = 'lightgray'
    if (!hasValue(bottomNavagationBarSelectedItemColor)) bottomNavagationBarSelectedItemColor = 'gray'

    if (!hasValue(logo)) {
        const color = tinycolor(backgroundColor)
        if (color.isDark()) logo = lucyLogoLight
        else logo = lucyLogoDark
    }

    if (!hasValue(loginLogo)) loginLogo = 'https://static.iviva.com/lucy/logos/lucy-canvas-square-256.png'

    const { homeTab, otherTabs, settingsTab, searchTab } = extractTabs(props.tabs)
    const _tabs = [homeTab, ...otherTabs, settingsTab, searchTab]
    const selectedTabIndex = _tabs.findIndex(t => t.id === props?.selectedTab?.id)

    function renderAdditionalConfigurations() {

        if (props?.selectedTab?.type == 'mobile' && props?.selectedTab?.props?.mobile == 'Settings Page') {
            return <div className="mobile-ui-editor-body">
                <SelectableItem
                    designer={props.designer}
                    props={[
                        {
                            id: 'sections',
                            value: props?.selectedTab?.props?.sections || [],
                            definition: { defaults: props?.selectedTab?.props?.sections || [], render: SettingSectionEditor }
                        }
                    ]}
                >
                    <div className="mobile-ui-editor-settings-container">
                        <div className="mobile-ui-editor-settings-container-heading">
                            Click here to configure sections in settings page
                        </div>

                        <div className="mobile-ui-editor-settings-container-body">
                            {(props?.selectedTab?.props?.sections || [])?.map((s: ISettingsPageSection, i: number) => {
                                return <div className="mobile-ui-editor-settings-section">
                                    <div className="icon">
                                        <FontAwesomeIcon icon={generateIconProp(s.icon)} />
                                    </div>
                                    <div className="label">{s.label}</div>
                                </div>
                            })}
                        </div>
                    </div>
                </SelectableItem>
            </div>
        }
        return null
    }

    function renderSelectedTabContent() {

        if (props?.selectedTab) {
            if (props?.selectedTab?.type == 'sections') {
                return <FieldContainer
                    {...props}
                    isMobile={false}
                    droppableContainerId='mobile-home-page'
                />
            }
            else if (props?.selectedTab?.type == 'mobile') {
                return <div className="mobile-ui-editor-container">

                    <div className="mobile-ui-editor-header">

                        <AutoCompleteInput
                            value={props?.selectedTab?.props?.mobile}
                            onChange={s => {
                                const _props = { ...props?.selectedTab }
                                jp.apply(_props, '$.props.mobile', () => s)
                                props.onChangeTab(_props)
                            }}
                            options={['Qr Code Scanner', 'Settings Page']}
                            placeholder="Enter custom UI or select one"
                        />
                    </div>

                    {renderAdditionalConfigurations()}
                </div>
            }
            else if (props?.selectedTab?.type == 'on-click') {
                return <div className="action-editor-btn">

                    <ActionEditorLink
                        action={props?.selectedTab?.props?.onClick}
                        onChange={s => {
                            const _props = { ...props?.selectedTab }
                            jp.apply(_props, '$.props.onClick', () => s)
                            props.onChangeTab(_props)
                        }}
                        designer={props.designer}
                        uiProps={props.uiProps}
                        uxpContext={props.uxpContext}
                    />
                </div>
            }
            else {
                return <WidgetSelector
                    widget={props?.selectedTab?.props?.widget}
                    onChange={s => {
                        const _props = { ...props?.selectedTab }
                        jp.apply(_props, '$.props.widget', () => s)

                        props.onChangeTab(_props)
                    }}
                    uxpContext={props.uxpContext}
                />
            }
        }
        return null
    }

    return <div className="wd-mobile-config-mobile-layout-container" style={{ scale: zoom.toString() }}
        id="widget-designer-widget-layout-container-rpxgtrs"
    >
        <div className="wd-mobile-config-mobile-layout"> </div>
        {view == 'home' ?
            <div className="wd-mobile-config-mobile-content-container" style={{ backgroundColor: backgroundColor }}>


                <div className="wd-mobile-config-header" style={{ backgroundColor: backgroundColor }}>
                    <div className="wd-mobile-config-header-logo-container">
                        <div className="wd-mobile-config-header-logo" style={{ backgroundImage: `url(${logo})` }}>
                        </div>
                    </div>

                    <div className="wd-mobile-config-header-actions">

                        <div className="wd-mobile-config-header-icon">
                            <div className={classNames("wd-mobile-config-header-icon-container", { 'active': props.selectedTab?.id === searchTab?.id })}
                                onClick={e => {
                                    props.onChangeTab(searchTab)
                                }}
                            >
                                <FontAwesomeIcon icon={['fas', 'search']} />
                            </div>
                        </div>

                        <div className="wd-mobile-config-header-icon">
                            <FontAwesomeIcon icon={['fas', 'bell']} />
                        </div>
                    </div>
                </div>


                <div className="wd-mobile-config-footer" style={{ backgroundColor: bottomNavigationBarBackgroundColor }} >
                    <SelectableItem
                        designer={props.designer}
                        props={[
                            {
                                id: 'tabs',
                                value: props?.uiProps?.tabs || [],
                                definition: { defaults: props?.uiProps?.tabs || [], render: MobileTabsEditor }
                            }
                        ]}
                    >
                        <div className="wd-mobile-config-footer-buttons"
                            onClick={e => {
                                props.onChangeTab(null)
                            }}
                        >

                            {
                                props?.tabs?.filter(t => (!t?.location || t?.location === 'navigation-bar'))?.map((t: IMobileNavigationTab, i: number) => {

                                    const isActive = props?.selectedTab?.id == t.id
                                    return <div className="wd-mobile-config-footer-button" style={{ color: isActive ? bottomNavagationBarSelectedItemColor : bottomNavigationBarUnselectedItemColor }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            props.onChangeTab(t)
                                        }}
                                    >
                                        <FontAwesomeIcon icon={generateIconProp(t.icon)} />
                                    </div>
                                })
                            }
                        </div>
                    </SelectableItem>
                </div>

                {renderSelectedTabContent()}
            </div>
            :
            <div className="wd-mobile-config-mobile-login-page" style={{ backgroundImage: `url(${backgroundImage})` }}>

                <div className="logo"
                    style={{ backgroundImage: `url(${loginLogo})` }}
                ></div>

                <div className="login-ui">
                    <div className="input"></div>
                    <div className="input"></div>
                    <div className="button"></div>
                </div>

            </div>
        }
    </div >
}


export function extractTabs(tabs: IMobileNavigationTab[]) {
    let homeTab = tabs?.find(t => t.id === 'home')
    let settingsTab = tabs?.find(t => t.id === 'settings')
    let searchTab = tabs?.find(t => t.id === 'searchIcon')

    const otherTabs = tabs.filter(t => !['home', 'settings', 'searchIcon'].includes(t.id))

    if (!homeTab) {
        homeTab = { id: 'home', label: 'Home', icon: 'home', type: 'sections', props: { fields: [], widget: null, mobile: null }, location: 'navigation-bar' }
    }

    if (!settingsTab) {
        settingsTab = { id: 'settings', label: 'Settings', icon: 'cog', type: 'mobile', props: { fields: [], widget: null, mobile: 'settings' }, location: 'navigation-bar' }
    }

    if (!searchTab) {
        searchTab = { id: 'searchIcon', label: 'Search', icon: 'search', type: 'on-click', props: { fields: [], widget: null, mobile: null, onClick: { type: 'open-url' } }, location: 'app-header' }
    }

    let addNew: IMobileNavigationTab = null
    if (otherTabs.length < 3) {
        addNew = {
            id: '__add__',
            label: 'Add',
            icon: 'plus',
            type: 'sections',
            props: {},
            location: 'navigation-bar'
        }
    }

    return { homeTab, settingsTab, searchTab, otherTabs, addNew }
}


type ITabs = IMobileNavigationTab[]
const MobileTabsEditor: React.FunctionComponent<IPropertyEditorProps<ITabs>> = (props) => {

    const tabs = props.uiProps || []

    const { homeTab, settingsTab, searchTab, otherTabs, addNew } = extractTabs(tabs)


    function updateProps(id: string, key: string, value: string) {
        const _tabs = [homeTab, ...otherTabs, settingsTab, searchTab]

        const updated = _tabs.map(t => {
            if (t.id == id) {
                (t as any)[key] = value
            }

            return t
        })
        props.onChange(updated)
    }

    function renderTab(t: IMobileNavigationTab, canRemove?: boolean) {

        if (t.id == '__add__') {
            return <div className="wd-mobile-navigation-tabs-config-tab">
                <Button
                    className="new-option"
                    title="Add Tab"
                    icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                    iconPosition="right"
                    onClick={() => {
                        otherTabs.push({
                            id: generateUUID(),
                            label: `Tab ${otherTabs.length + 1}`,
                            icon: getRandomIcon(),
                            props: { fields: [], widget: null, mobile: null },
                            type: 'sections',
                            location: 'navigation-bar'
                        })

                        props.onChange([homeTab, ...otherTabs, settingsTab, searchTab])
                    }}
                    active={true}
                />
            </div>
        }

        return <div className="wd-mobile-navigation-tabs-config-tab">

            {canRemove &&
                <div className="wd-mobile-navigation-tabs-config-tab-remover"
                    onClick={() => {
                        const updated = otherTabs.filter(ot => ot.id !== t.id)
                        props.onChange([homeTab, ...updated, settingsTab, searchTab])
                    }}
                >
                    <FontAwesomeIcon icon={['fas', 'times']} />
                </div>
            }

            <div className="wd-mobile-navigation-tabs-config-label">{t.label}</div>

            <div className="wd-mobile-navigation-tabs-config-content">
                <div className="section">
                    <Label>Name</Label>
                    <Input
                        value={t.label}
                        onChange={s => {
                            updateProps(t.id, 'label', s)
                        }}
                        className="widget-designer-input"
                    />
                </div>

                <div className="section">
                    <Label>Icon</Label>
                    <IconEditor
                        value={t.icon}
                        onChange={s => {
                            updateProps(t.id, 'icon', s)
                        }}
                    />
                </div>

                <div className="section">
                    <Label>Type</Label>
                    <Select
                        selected={t.type}
                        onChange={s => {
                            updateProps(t.id, 'type', s)
                        }}
                        options={[
                            { label: 'Sections', value: 'sections' },
                            { label: 'Widget', value: 'widget' },
                            { label: 'Custom Mobile Page', value: 'mobile' }
                        ]}
                        className="widget-designer-input"
                    />
                </div>
            </div>
        </div>
    }

    return <PropertyContainer>
        <PropertyGroup>
            <PropertyGroupTitle>Configure Tabs</PropertyGroupTitle>

            <div className="wd-mobile-navigation-tabs-config-container">

                {!!homeTab && renderTab(homeTab)}

                {otherTabs?.map(t => (renderTab(t, true)))}

                {!!addNew && renderTab(addNew)}

                {!!settingsTab && renderTab(settingsTab)}
            </div>


        </PropertyGroup>
    </PropertyContainer>
}

type ISections = ISettingsPageSection[]
const SettingSectionEditor: React.FunctionComponent<IPropertyEditorProps<ISections>> = (props) => {

    const sections = props.uiProps || []

    function renderSection(s: ISettingsPageSection, i: number) {
        return <div className="wd-mobile-navigation-tabs-config-tab">

            <div className="wd-mobile-navigation-tabs-config-tab-remover"
                onClick={() => {
                    const updated = sections.filter(item => item.id !== s.id)
                    props.onChange(updated)
                }}
            >
                <FontAwesomeIcon icon={['fas', 'times']} />
            </div>


            <div className="wd-mobile-navigation-tabs-config-label">{s.label}</div>

            <div className="wd-mobile-navigation-tabs-config-content">
                <div className="section">
                    <Label>Name</Label>
                    <Input
                        value={s.label}
                        onChange={v => {
                            const updated = sections.map(item => {
                                if (item.id === s.id) {
                                    s.label = v
                                }
                                return item
                            })
                            props.onChange(updated)
                        }}
                        className="widget-designer-input"
                    />
                </div>

                <div className="section">
                    <Label>Icon</Label>
                    <IconEditor
                        value={s.icon}
                        onChange={v => {
                            const updated = sections.map(item => {
                                if (item.id === s.id) {
                                    s.icon = v
                                }
                                return item
                            })
                            props.onChange(updated)
                        }}
                    />
                </div>

                <div className="section">
                    <Label>On Click</Label>
                    <ActionEditorLink
                        action={s.onClick}
                        onChange={v => {
                            const updated = sections.map(item => {
                                if (item.id === s.id) {
                                    s.onClick = v
                                }
                                return item
                            })
                            props.onChange(updated)
                        }}
                        uxpContext={props.uxpContext}
                        uiProps={props.uiProps}
                        settings={{
                        }}
                    />
                </div>
            </div>
        </div>
    }
    return <PropertyContainer>
        <PropertyGroup>
            <PropertyGroupTitle>Configure Sections</PropertyGroupTitle>
            <div className="wd-mobile-navigation-tabs-config-container">
                {props.uiProps?.map((s, i) => renderSection(s, i))}

                <div className="wd-mobile-navigation-tabs-config-tab">
                    <Button
                        className="new-option"
                        title="Add Tab"
                        icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                        iconPosition="right"
                        onClick={() => {
                            sections.push({
                                id: generateUUID(),
                                label: `Section ${sections.length + 1}`,
                                icon: getRandomIcon(),
                                onClick: { type: 'open-url' }
                            })

                            props.onChange(sections)
                        }}
                        active={true}
                    />
                </div>
            </div>
        </PropertyGroup>
    </PropertyContainer>
}

interface IWidgetSelectorProps {
    uxpContext: IContextProvider
    widget: { name: string, id: string },
    onChange: (widget: { name: string, id: string }) => void
}
export const WidgetSelector: React.FunctionComponent<IWidgetSelectorProps> = (props) => {

    const [widgets, setWidgets] = useState([])

    const alerts = useAlert()

    useEffect(() => {
        getAllWidgets()
    }, [])

    function getName(widget: any) {
        if (hasValue(widget?.name)) return widget.name
        else if (hasValue(widget?.title)) return widget.title
        else if (hasValue(widget?.label)) return widget.label
        else return 'unknown'
    }

    function getAllWidgets() {
        props.uxpContext?.executeService('UXP', 'GetWidgets', { pageNumber: 0, max: 100000 }, { json: true })

            .then((res) => {
                let data = res[0]
                let widgets = tryParseJSON(data.widgets, [])
                setWidgets(widgets.map((w: any) => ({ ...w, name: getName(w) })));
            })
            .catch(e => {
                console.log('exception getting widgets', e);
                setWidgets([])
            })
    }


    function getLabel() {
        const widget = widgets.find(w => (w.id == props?.widget?.id && w.name == props?.widget?.name))
        if (widget) return widget.name
        else return 'Select a widget'
    }

    async function onSelectWidget() {
        try {

            const data = await alerts.form({
                title: 'Select a widget',
                formStructure: [
                    {
                        name: 'widget',
                        label: 'widget',
                        type: 'select',
                        options: widgets?.map(w => ({ label: w.name, value: `${w.name}####${w.id}` })),
                        validate: {
                            required: true
                        }
                    }
                ]
            })
            if (!hasValue(data.widget)) alert('Widget is required')
            const parts = data.widget?.split("####")
            props.onChange({ name: parts[0], id: parts[1] })
        } catch (e) {

        }
    }

    return <div className="wd-mobile-config-widget-selector">
        <Button
            title={getLabel()}
            onClick={onSelectWidget}
        />
    </div>
}